import { render, staticRenderFns } from "./flight-bags.vue?vue&type=template&id=6a9ea5a6&scoped=true"
import script from "./flight-bags.vue?vue&type=script&lang=js"
export * from "./flight-bags.vue?vue&type=script&lang=js"
import style0 from "./flight-bags.vue?vue&type=style&index=0&id=6a9ea5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ea5a6",
  null
  
)

export default component.exports